export type RevisionDecision = "apply" | "duplicate" | "gap";
export class RevisionTracker {
  constructor(public current = -1) {}
  classify(incoming: number): RevisionDecision { if (incoming <= this.current) return "duplicate"; if (this.current >= 0 && incoming > this.current + 1) return "gap"; return "apply"; }
  accept(incoming: number): RevisionDecision { const decision = this.classify(incoming); if (decision === "apply") this.current = incoming; return decision; }
  rebase(revision: number): void { if (revision >= this.current) this.current = revision; }
}
